exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader{font-size:8px;position:relative;text-indent:-9999em;border-top:.75em solid pink;border-right:.75em solid pink;border-bottom:.75em solid pink;border-left:.75em solid #c10e21;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation:load8 1.1s infinite linear;animation:load8 1.1s infinite linear}.loader,.loader:after{border-radius:50%;width:5em;height:5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0aa2e352","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/components/aha-sitecore-form-wrapper.vue
// module id = 937
// module chunks = 0